import { useTranslation } from 'react-i18next'
import { List } from '@chakra-ui/react'
import { Region } from '@leid/api-locations'

import { ButtonOutlined } from 'components/ui/Buttons/Button'

import { RegionWithAvailability } from '..'

type Props = {
  index: number
  listSize: number
  selectedRegionId: number | undefined
  handleChange: (region: Region) => void
  region: RegionWithAvailability
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  regionsLength: number
}

const RegionButton = (props: Props): JSX.Element => {
  const { index, listSize, selectedRegionId, region, handleChange, collapsed, setCollapsed, regionsLength } = props

  const { t } = useTranslation(['locations'])

  return (
    <>
      <List.Item
        onClick={() => handleChange(region)}
        hidden={index >= listSize ? !collapsed : undefined}
        unselectable={index < listSize ? 'on' : undefined}
        marginRight={5}
        marginBottom={5}
        listStyleType="none"
      >
        <ButtonOutlined
          isSelected={selectedRegionId && selectedRegionId === region.id ? true : false}
          isDimmed={region.hasAvailableLocations === false}
          isOff={region.hasAvailableLocations === undefined}
        >
          {region.name}
        </ButtonOutlined>
      </List.Item>

      {index === regionsLength - 1 && (
        <List.Item
          key="divider"
          onClick={() => setCollapsed(!collapsed)}
          marginRight={5}
          marginBottom={5}
          listStyleType="none"
        >
          <ButtonOutlined key="divider" noBorder={true}>
            {collapsed ? t('less') : t('more')}
          </ButtonOutlined>
        </List.Item>
      )}
    </>
  )
}

export default RegionButton
